import InfoButton from './modal/aboutButton';
import { styles } from '../assets/styles';

export function Footer() {
  return (
    <>
      <div style={styles.infoButtonDiv}>
        <InfoButton />
      </div>
      <footer style={styles.footer}>pikadle.app - made by rotincol</footer>
    </>
  );
}
